// API Configuration - determines the correct API endpoint based on the current environment

// Get the API base URL (routed endpoints via index.php)
export const getAPIBase = () => {
  const hostname = window.location.hostname;
  
  // Production environment
  if (hostname === 'permataharapansecondary.sch.id' || hostname === 'www.permataharapansecondary.sch.id') {
    return 'https://permataharapansecondary.sch.id/api';
  }
  
  // Development localhost (http)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost/permataharapan-api/api';
  }
  
  // Fallback for any other domain - construct from current location
  const protocol = window.location.protocol;
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${protocol}//${hostname}${port}/api`;
};

// Alias for backwards compatibility
export const getBackendBase = getAPIBase;

export const BACKEND_BASE = getBackendBase();
export const API_BASE = getAPIBase();

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE}${endpoint}`;
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Include cookies for session
  };
  
  const finalOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };
  
  const response = await fetch(url, finalOptions);
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  API_BASE,
  apiCall,
  getAPIBase,
};
